<template>
    <load v-if="loading" message="Carregando informações do técnico" />
    <div v-else>
        <div class="col d-flex justify-content-between align-items-center">
            <div class="col-md-auto px-0">
                <h1 class="h3 mb-3 text-gray-800">
                    {{ $t("Editar Técnico") }}
                </h1>
            </div>
            <div class="col-md-auto">
                <nav aria-label="breadcrumb" v-if="item">
                    <ol class="breadcrumb" style="display: flex">
                        <li class="breadcrumb-item active" aria-current="page">
                            <router-link :to="`/dashboard/tecnicos`">
                              Técnico(a)
                            </router-link>
                        </li>
                        <li class="breadcrumb-item active" aria-current="page">
                            {{ item.nome }}
                        </li>
                    </ol>
                </nav>
            </div>
        </div>
        <div class="row">
            <div class="col-md-4 d-flex align-items-stretch">
                <Acesso
                    :item="item"
                    :status="status"
                    :status_item="status_item"
                    :loading="loadingStatus"
                    :passwordInput="passwordInput"
                    @verificar="verificarStatus"
                    @generate="generatePassword"
                    @add="addItem" 
                />
            </div>
            <div class="col-md-8 d-flex align-items-stretch">
                <b-card class="shadow col-12">
                    <template v-slot:default>
                        <b-tabs content-class="mt-3" fill>
                            <Informacao
                                :item="item"
                                :showAssinatura="showAssinatura"
                                @add="addItem"
                            />
                            <Unidade
                                :item="item"
                                :roles="roles"
                                :unidades="unidades"
                                :unidadesTecnico="unidades_tecnico"
                                :showAssinatura="showAssinatura"
                                :disabledRole="disabledRole"
                                @add="addItem"
                            />
                            <Assinatura
                                :item="item"
                                :roles="roles"
                                :showAssinatura="showAssinatura"
                                @add="addItem"
                            />
                        </b-tabs>
                    </template>
                </b-card>
            </div>
        </div>

        <!-- MODAL ALTERAR STATUS DO TECNICO -->
        <status-historico
            :model="model"
            modulo="Tecnico"
            titulo_modulo="TÉCNICO"
            :nome="item.nome"
            :id="item.id"
            :status-anterior="statusAnterior"
            :status-atual="statusAtual"
            :status="status_item"
            @submit="addItem"
        />
    </div>
</template>
<script>
import HistoricoStatus from "./HistoricoStatus";

import Acesso from "./includes/Acesso";
import Assinatura from "./includes/Assinatura";
import Informacao from "./includes/Informacao";
import Unidade from "./includes/Unidade";
export default {
    name: "Edit",
    components: {
        HistoricoStatus,
        Acesso,
        Assinatura,
        Informacao,
        Unidade,
    },
    data() {
        return {
            loadingStatus       : false,
            loadingSearchUnidade: false,
            showAssinatura      : false,
            loading             : true,
            tecnicosList        : [],
            localidades         : [],
            localidade          : {},
            logradouros         : [],
            logradouro          : {},
            unidades            : [],
            passwordInput       : "password",
            item                : { status: 1 },
            roles               : [],
            files               : [],
            disabledRole        : false,
            model               : "Tecnico",
            status              : {},
            status_item         : [],
            statusAtual         : "",
            statusAnterior      : "",
            unidades_tecnico    : [],
            showUnidade         : true,
            progressCompleted   : 0,
            data_nascimento     : null,
        };
    },
    mounted() {
        this.getTecnico();
        this.getStatus();
        this.getRoles();
        this.getUnidades();
        this.getStatusFinais();
    },
    methods: {
        getTecnico() {
            this.loading = true;
            axios
                .get("api/dashboard/tecnicos/" + this.$route.params.id)
                .then((response) => {
                    this.item = response.data.data;
                    this.unidades_tecnico = this.item.unidades;
                    this.statusAnterior = this.item.status;
                    if (this.item.role_id == 1) {
                        this.item.role_id = {
                            id: 1,
                            value: "Admin",
                        };
                        this.disabledRole = true;
                    }
                })
                .finally(() => {
                    this.loading = false;
                })
                .catch((error) => {
                    swal.fire({
                        title: "Ops!",
                        html:
                            "O item não foi carregado corretamente<br>" + error,
                        icon: "error",
                    });
                });
        },
        getUnidades() {
            this.loadingSearchUnidade = true;
            axios
                .get(`api/dashboard/unidades/get/externas`)
                .then((response) => {
                    this.unidades = response.data;
                })
                .finally(() => (this.loadingSearchUnidade = false));
        },
        getStatus() {
            this.loadingStatus = true;
            axios
                .get(`api/dashboard/status/tecnicos`)
                .then((response) => {
                    this.status = response.data;
                })
                .finally(() => {
                    this.loadingStatus = false;
                });
        },
        verificarStatus(status) {
            this.statusAtual = status;
            const result = this.status_item.filter((item) => item.id == status);
            if (result[0].final == 1) {
                //compara os status finais com o status que foi alterado, caso seja igual será aberta a janela para salva o historico
                this.$bvModal.show("status-historico-" + this.model);
            }
        },
        getStatusFinais() {
            axios.post(`api/dashboard/get/status/finais`, {
                    model: this.model,
                    module: this.model,
                })
                .then((response) => {
                    this.status_item = response.data;
                });
        },
        addItem() {
            let ladda = Ladda.create(document.querySelector(".btn-submit"));
            ladda.start();

            if (this.item.role_id.value == "Admin") {
                this.item.role_id = 1;
            }
            this.item.unidades = this.unidades_tecnico;

            if (this.item.unidades && this.item.unidades.length > 0) {
                this.item.unidades = this.item.unidades.filter((element) => {
                    if (element.unidade_id != null) {
                        return element;
                    }
                });
            }

            // Send request
            axios
                .put(`api/dashboard/admin/tecnicos/${this.item.id}`, this.item)
                .then((response) => {
                    ladda.stop();
                    this.getTecnico();
                    this.$snack.success({
                        button: false,
                        text: response.data.data.message,
                    });
                }).finally(()=>{
                    // location.reload();
                });
        },
        // Show the password input
       
        // Generate new password
        generatePassword() {
            this.item.password = window.GeneratePassword.generate({
                length: 8,
                numbers: true,
                symbols: false,
                excludeSimilarCharacters: true,
                strict: true,
            });
        },
        getRoles() {
            this.loading = true;
            // Get all settings values
            axios.get("api/dashboard/users/roles").then((response) => {
                if (response.data.data) {
                    this.roles = response.data.data.map((elem) => ({
                        id: elem.id,
                        value: elem.name,
                    }));
                }
                this.loading = false;
            });
        },
        onSearchLocalidade(search, loading) {
            loading(true);
            this.searchLocalidade(loading, search, this);
        },
        searchLocalidade(loading, search, vm) {
            axios.get(`api/dashboard/enderecos/pesquisar_bairro?q=${escape(search)}`)
                .then((response) => {
                    this.localidades = response.data;
                    loading(false);
                });
        },
        setSelected(value) {
            axios.get(`api/dashboard/enderecos/pesquisar_logradouro?logradouro=${escape(value.id)}`)
                .then((response) => {
                    this.logradouros = response.data;
                });
        },
    },
};
</script>
